/**
 * A decode can "succeed" with nothing in it: a JPEG 2000 frame that comes back 0x0, or with fewer
 * pixels than its rows x columns. cornerstone then draws a blank cell and no error ever reaches the
 * reference-image fallback. Rejecting such an image turns it into a decode failure, which the shell
 * already answers with "Resolución de referencia" (or a visible error).
 */

export interface DecodedImage {
  rows: number;
  columns: number;
  color?: boolean;
  minPixelValue?: number;
  maxPixelValue?: number;
  getPixelData?: () => ArrayLike<number> | undefined;
}

/** Why a decoded image cannot be shown, or undefined when it is fine. */
export function decodedImageProblem(image: DecodedImage | undefined): string | undefined {
  if (!image) return 'no image';
  if (!(image.rows > 0) || !(image.columns > 0)) return `empty size ${image.rows}x${image.columns}`;
  const pixels = image.getPixelData?.();
  if (!pixels || pixels.length < image.rows * image.columns) return `pixel data shorter than ${image.rows}x${image.columns}`;
  if (!image.color && (!Number.isFinite(image.minPixelValue) || !Number.isFinite(image.maxPixelValue))) return 'no pixel range';
  return undefined;
}
